import gql from "graphql-tag";

import type {GqlFetchFn} from "@khan/data-gql";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {Errors, KAError} from "@khan/logging";

import type {ProgramSettings} from "../scratchpad-ui.tsx";

import type {
    updateProgramSettings as updateProgramSettingsResult,
    updateProgramSettingsVariables,
} from "./__graphql-types__/updateProgramSettings.ts";
import {mapToProgramSettings} from "./gql-type-mappers.ts";

export const UPDATE_PROGRAM_SETTINGS_MUTATION: GqlOperation<
    updateProgramSettingsResult,
    updateProgramSettingsVariables
> = gqlOp(gql`
    mutation updateProgramSettings(
        $programId: ID!
        $height: Int!
        $width: Int!
        $category: ProgramCategoryInput
        $description: String
    ) {
        updateProgramSettings(
            programId: $programId
            height: $height
            width: $width
            category: $category
            description: $description
        ) {
            program {
                id
                height
                width
                category
                description
            }
            error {
                code
                debugMessage
            }
        }
    }
`);

export const updateProgramSettings = async (
    gqlFetch: GqlFetchFn,
    variables: updateProgramSettingsVariables,
): Promise<ProgramSettings> => {
    const result = await gqlFetch(UPDATE_PROGRAM_SETTINGS_MUTATION, {
        variables,
    });

    const errorCode = result.updateProgramSettings?.error?.code;
    if (errorCode) {
        throw new KAError(errorCode, Errors.GraphqlResponse);
    }

    const program = result.updateProgramSettings?.program;
    if (!program) {
        throw new KAError("Failed to update program settings", Errors.Internal);
    }
    return mapToProgramSettings(program);
};
